import { Box, ListItem, Text, UnorderedList } from '@chakra-ui/react';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';

function EmailGroup({ name, emails, ...rest }) {
  return (
    emails &&
    Array.isArray(JSON.parse(emails)) && (
      <Box w="100%" fontSize="xs" {...rest}>
        {JSON.parse(emails).length > 0 && <Text fontWeight={500}>{name}</Text>}

        <UnorderedList ml={5}>
          {JSON.parse(emails).map((email) => (
            <ListItem key={uuidv4()} m={2}>
              {email}
            </ListItem>
          ))}
        </UnorderedList>
      </Box>
    )
  );
}

EmailGroup.defaultProps = {
  emails: null,
};

EmailGroup.propTypes = {
  emails: PropTypes.string,
  name: PropTypes.string.isRequired,
};

export default EmailGroup;
